import { React, PropTypes, reduxConnect, styled, css, useEffect, useState } from '../lib/imports';
import { Spacing, Heading, AdvertisingTile } from '../components';

import { setOfferClicked } from '../offers/actions';

const offerContentBaseStyles = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${theme.colors.g500};
  margin-top: ${theme.spacings.byte};
`;

const OfferContent = styled('div')(offerContentBaseStyles);

const Offers = ({ handleOfferClick, ...props }) => {
  const { isClicked, promotions } = props;
  const [redirected, setRedirected] = useState('');
  useEffect(() => {
    if (isClicked) {
      window.location.href = redirected;
    }
  }, [isClicked, redirected]);

  const renderAdvertisingTiles = () => {
    if (Object.values(promotions[0]).length > 1) {
      return promotions.map((promotion, index) => {
        return (
          <AdvertisingTile
            key={index}
            onSelect={() => {
              handleOfferClick();
              setRedirected(promotion.goTo);
            }}
            src={promotion.imgSrc}
            alt={promotion.altText}
          />
        );
      });
    }
  };

  return !promotions?.length ? null : (
    <Spacing sizeTop='giga' sizeBottom='giga' sizeLeft='giga' sizeRight='giga'>
      <div>
        <Heading as='h3' noMarginBoth>
          Offers and Products
        </Heading>
        <OfferContent>{renderAdvertisingTiles()}</OfferContent>
      </div>
    </Spacing>
  );
};

Offers.propTypes = {
  handleOfferClick: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { strings, offers } = state;

  const allStrings = {
    text: strings['notifications/reminders/toggle/text'],
  };

  return {
    ...allStrings,
    ...offers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleOfferClick: () => dispatch(setOfferClicked()),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Offers);
